var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArticle = function SvgIconArticle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.496 1.326A1.48 1.48 0 0 1 1.541.893h8.334a1.48 1.48 0 0 1 1.478 1.479v.188h1.855a1.48 1.48 0 0 1 1.478 1.478v9.167a2.31 2.31 0 0 1-2.311 2.312H3.208a3.145 3.145 0 0 1-3.145-3.145v-10c0-.392.156-.768.433-1.046m9.805 12.9H3.208a1.855 1.855 0 0 1-1.855-1.854v-10a.19.19 0 0 1 .188-.189h8.334a.19.19 0 0 1 .188.189v10.833c0 .358.083.707.238 1.022M11.353 3.85v9.355a1.022 1.022 0 1 0 2.043 0V4.038a.19.19 0 0 0-.188-.188z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.396 4.872c0-.356.29-.645.645-.645h3.334a.645.645 0 1 1 0 1.29H4.04a.645.645 0 0 1-.645-.645M3.396 8.205c0-.356.29-.645.645-.645h3.334a.645.645 0 0 1 0 1.29H4.04a.645.645 0 0 1-.645-.645M3.396 11.539c0-.357.29-.646.645-.646h3.334a.645.645 0 1 1 0 1.29H4.04a.645.645 0 0 1-.645-.644",
    clipRule: "evenodd"
  })));
};
export default SvgIconArticle;